export default __webpack_public_path__ + "static/media/993.e991104c.gif";